/*
 * @description 获取app相关信息
 * ADLINK_ID
 * ADYEN_3DINFO
 * APP_BUILDVERSION
 * APP_CURRENCY_INFO
 * APP_VERSION
 * COUNTRY
 * DEVICE_ID
 * EMAIL
 * HOME_POSITION
 * LANGUAGE
 * LAST_URL
 * PAGE_POSITION
 * PATPAT_EXPERIMENTS
 * PIN
 * PLATFORM
 * SETTING_COUNTRY
 * SITE_ABB
 * TIMEZONE
 * TIMEZONE_NAME
 * USER_ID
 * USER_TOKEN
 * IPHONE_STATEBAR_HEIGHT
 * IPHONE_BOTTOM_SAFE_HEIGHT
 */
const isClient = typeof window !== 'undefined' && typeof window === 'object'
window.getAppInfo = (PatPat = {}, language = 'en') => {
  let nav = {}
  if (isClient && window.navigator) {
    // 客户端
    nav = window.navigator
  }
  const u = getPatPatKey(nav, 'userAgent', '')
  const platform = getPatPatKey(PatPat, 'PLATFORM', 'wap')
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 || platform === 'android' // android
  const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) || platform === 'ios' // ios
  const hostEnv = {
    isIos: isiOS,
    isAndroid: isAndroid,
    appNavVersion: getPatPatKey(nav, 'appVersion', ''),
    pin: getPatPatKey(PatPat, 'PIN', ''),
    token: getPatPatKey(PatPat, 'USER_TOKEN', ''),
    userLevel: getPatPatKey(PatPat, 'USER_MEMBER_LEVEL', 0), // 9.8版本补充会员等级信息
    userId: getPatPatKey(PatPat, 'USER_ID', ''),
    shopifyUserId: getPatPatKey(PatPat, 'SHOPIFY_USER_ID', ''),
    country: getPatPatKey(PatPat, 'SETTING_COUNTRY', ''), // 国家名称
    siteAbb: getPatPatKey(PatPat, 'SITE_ABB', ''), // 站点
    currencyInfo: getPatPatKey(PatPat, 'APP_CURRENCY_INFO', ''), // 货币信息
    appVersion: getPatPatKey(PatPat, 'APP_VERSION', ''),
    isLogin: false,
    experiments: getPatPatKey(PatPat, 'PATPAT_EXPERIMENTS', '') || '', // app实验参数
    language: getPatPatKey(PatPat, 'LANGUAGE', language), // app语言
    deviceID: getPatPatKey(PatPat, 'DEVICE_ID', ''), // 设备ID
    adlinkId: getPatPatKey(PatPat, 'ADLINK_ID', ''), // adlk_id
    adyen3Dinfo: getPatPatKey(PatPat, 'ADYEN_3DINFO', '') || '',
    appBuildVersion: getPatPatKey(PatPat, 'APP_BUILDVERSION', ''),
    countryCode: getPatPatKey(PatPat, 'COUNTRY', ''), // 国家码
    email: getPatPatKey(PatPat, 'EMAIL', ''),
    phone: getPatPatKey(PatPat, 'PHONE', ''),
    homePosition: getPatPatKey(PatPat, 'HOME_POSITION', '') || '',
    lastUrl: getPatPatKey(PatPat, 'LAST_URL', '') || '',
    pagePosition: getPatPatKey(PatPat, 'PAGE_POSITION', '') || '',
    lastTid: getPatPatKey(PatPat, 'LAST_TID', '') || '',
    lastPagePositionId: getPatPatKey(PatPat, 'LAST_PAGE_POSITION_ID', '') || '', // -- 新规则埋点坑位
    lastPagePositionContent: getPatPatKey(PatPat, 'LAST_PAGE_POSITION_CONTENT', '') || '', // -- 新规则埋点坑位内容
    rootPagePositionId: getPatPatKey(PatPat, 'ROOT_PAGE_POSITION_ID', '') || '', //  -- 新规则埋点坑位， 内容可复用HOME_POSITION_CONTENT
    platform: platform, // ios | android | wap
    timeZone: decodeURIComponent(getPatPatKey(PatPat, 'TIMEZONE', '')), // GTM+8
    timeZoneName: decodeURIComponent(getPatPatKey(PatPat, 'TIMEZONE_NAME', '')), // Asia/Shanghai
    isReminded: getPatPatKey(PatPat, 'SYSTEM_PUSH_STATUS', ''),
    statusBarHeight: getPatPatKey(PatPat, 'IPHONESTATEBARHEIGHT', 0), // ios app状态栏高度， 安卓暂时没有
    TID: getPatPatKey(PatPat, 'TID', ''),
    isFromApp: platform === 'ios' || platform === 'android',
    homePositionContent: getPatPatKey(PatPat, 'HOME_POSITION_CONTENT', '') || '', // app 6.9才支持这两个字段
    pagePositionContent: getPatPatKey(PatPat, 'PAGE_POSITION_CONTENT', '') || '',
    appVersionNumber: 0, // app数字版本号
    sessionId: getPatPatKey(PatPat, 'SESSION_ID', ''), // app的session_id,7.5版本才支持
    pageViewTime: getPatPatKey(PatPat, 'PAGE_VIEW_TIME', 0), // app的page_view_time,7.5版本才支持
    iphoneStatebarHeight: getPatPatKey(PatPat, 'IPHONE_STATEBAR_HEIGHT', 0), // iphone 状态栏高度 7.7.6版本才支持 （之前的不准，ios开发说是写死的，现在这个是动态获取的）
    iphoneBottomSafeHeight: getPatPatKey(PatPat, 'IPHONE_BOTTOM_SAFE_HEIGHT', 0), // iphone 底部安全区域高度 7.7.6版本才支持
    shutdownIntercom: getPatPatKey(PatPat, 'IS_CLEAR_INTERCOM_SESSION', 0) // 是否需要销毁intercom聊天
  }
  try {
    hostEnv.language = hostEnv.language.includes('-') ? hostEnv.language.split('-')[0] : hostEnv.language
    hostEnv.isLogin = hostEnv.token && hostEnv.token !== 'guest'
    hostEnv.statusBarHeight = hostEnv.statusBarHeight - 0
    if (hostEnv.currencyInfo) {
      try {
        if (typeof hostEnv.currencyInfo === 'string') {
          hostEnv.currencyInfo = JSON.parse(hostEnv.currencyInfo)
        }
        if (hostEnv.currencyInfo.currencyCode) {
          hostEnv.currencyCode = hostEnv.currencyInfo.currencyCode
        }
      } catch (e) {
        console.log('APP_CURRENCY_INFO json parse error')
      }
    }
    hostEnv.appVersionNumber = Number(String(hostEnv.appVersion).split('.').reduce((item1, item2, index) => index === 1 ? (item1 + '.' + item2) : (item1 + item2)))
    // 若app小版本号大于9之后请使用下面这个版本拆解，小版本号将在0-99之间，之前的版本判断记得改动
    // hostEnv.appVersionNumber = Number(String('7.12.2').split('.').reduce((item1, item2, index) => index === 1 ? (item1 + '.' + String(item2).padStart(2, 0)) : (item1 + String(item2).padStart(2, 0))))
    if (hostEnv.appVersionNumber === 7.8) {
      // 7.8游客token不为'guest',加上邮箱判断。安卓游客邮箱为'null', ios为''
      hostEnv.isLogin = hostEnv.isLogin && hostEnv.userId && (hostEnv.email ? hostEnv.email !== 'null' : false)
    }
    if (hostEnv.appVersionNumber >= 7.9) {
      // 7.9.0 这个版本开始注入IS_LOGON这个字段, 7.8.0 版本判断用户是否登陆无效因为该版本开始游客也有user_id 和 user_token
      hostEnv.isLogin = !!getPatPatKey(PatPat, 'IS_LOGIN', false) // ios:  0 | 1  android: true | false
    }
    return hostEnv
  } catch (err) {
    console.log(err)
    return hostEnv
  }
}

const getPatPatKey = (o, k, df) => {
  if (isClient && window.PatPat && typeof window.PatPat === 'object') {
    // 安卓客户端只能在 window.PatPat 对象读取数据，否则报错，请不要将 window.PatPat 指派到其他对象在取值
    if (window.PatPat) {
      if (window.PatPat[k]) {
        if (typeof window.PatPat[k] === 'function') {
          try {
            return window.PatPat[k]()
          } catch (err) {
            return df
          }
        } else {
          return window.PatPat[k]
        }
      } else {
        return df
      }
    }
  }
  if (o && typeof o === 'object' && Object.prototype.hasOwnProperty.call(o, k)) {
    const v = o[k]
    if (typeof v === 'function') {
      return v()
    } else {
      return v
    }
  }
  return df
}

const findPlatform = () => {
  const appPatPat = window.PatPat
  if (appPatPat) {
    if (typeof appPatPat.PLATFORM === 'function') {
      return appPatPat.PLATFORM()
    } else if (appPatPat.PLATFORM) {
      return appPatPat.PLATFORM
    }
  } else {
    return 'wap'
  }
}

/**
 * 调用触发原生App某个函数
 * @param {String} functionName 函数名称 eg: share login refresh_cart
 * @param {Object} params
 * @param {Function} callback
 * @param {Object} other
 */
const onNativeFunction = (functionName, params, callback, other) => {
  window.nativeCallback = callback
  let typeObj = {
    method: functionName,
    content: params
  }
  if (other) {
    typeObj = Object.assign({}, typeObj, other)
  }
  if (findPlatform() == 'ios') {
    if (window.webkit && window.webkit.messageHandlers.jsCallWithCallback) {
      window.webkit.messageHandlers.jsCallWithCallback.postMessage(JSON.stringify(typeObj))
    }
  } else if (findPlatform() == 'android') {
    window.PatPat.jsCallWithCallback(JSON.stringify(typeObj))
  } else {
  }
}

